module.exports = __webpack_public_path__ + "static/media/profile-img.ba4e037e.png";